import React from 'react';
import { Flex, Box, Typography } from '@fullstory/components';

interface TooltipRowProps {
  rangeText: string;
  value: string;
}
export const TooltipRow: React.FC<TooltipRowProps> = ({ rangeText, value }) => (
  <Flex data-component="TooltipRow" justifyContent="space-between">
    <Box paddingRight={8}>
      <Typography color="white" variant="body3">
        {rangeText}:{' '}
      </Typography>
    </Box>
    <Typography color="white" variant="body3">
      {value}
    </Typography>
  </Flex>
);
